module.exports = __webpack_public_path__ + "static/media/craters.902907e6.png";